"use client";

import React, { useEffect, useRef, useState } from "react";
import { TrendingUp, Activity, Users, Network } from "lucide-react";
import { Badge } from "@/components/ui/badge";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) observer.unobserve(entry.target);
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
function AnimatedCounter({
  value,
  isVisible
}: {
  value: number;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number | null = null;
    const duration = 2500;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(ease * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(animate);
  }, [value, isVisible]);
  return <>{count.toLocaleString()}</>;
}
export default function PulseOfTheNetwork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const stats = [{
    id: 1,
    label: "AVG. SAVED ($)",
    value: 12,
    growth: "$12.50 PER ORDER",
    icon: TrendingUp
  }, {
    id: 2,
    label: "USERS IN GTA",
    value: 15000,
    growth: "15,000+ ACTIVE",
    icon: Users
  }, {
    id: 3,
    label: "MEALS SHARED",
    value: 40000,
    growth: "40,000+ SERVED",
    icon: Activity
  }];
  return;
}